// Français pour la page Document de périmètre. Enregistré au chargement.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Full': 'Complet',
  'Draft — requirements and deliverables only': 'Brouillon — exigences et livrables seulement',
  'Full — the complete Statement of Work structure': 'Complet — la structure intégrale du Statement of Work',
  'Mode': 'Mode',
  'Print': 'Imprimer',
  'Print the traceability sheets — A4 landscape, one deliverable per sheet': 'Imprimer les feuilles de traçabilité — A4 paysage, un livrable par feuille',
  'Rendered from the live register — not an issued SOW. Priority and type are editable here and write straight to the register; rows inside a signed baseline are locked.': 'Rendu depuis le registre en direct — ce n’est pas un SOW émis. La priorité et le type sont modifiables ici et écrivent directement dans le registre ; les lignes d’une ligne de base signée sont verrouillées.',
  'Select an engagement to render its scope document.': 'Sélectionnez un mandat pour rendre son document de périmètre.',
  'Loading the register…': 'Chargement du registre…',
  '{n} requirements': '{n} exigences',
  '{n} deliverables': '{n} livrables',
  'rendered {when}': 'rendu {when}',
  'Saved {ref}: {field} → {value}': '{ref} enregistré : {field} → {value}',
  'Locked — inside a signed baseline; change it through a change request.': 'Verrouillé — dans une ligne de base signée ; à modifier via une demande de changement.',
  // sections
  'Requirements': 'Exigences',
  'Deliverables': 'Livrables',
  'Parties and engagement': 'Parties et mandat',
  'Background and objectives': 'Contexte et objectifs',
  'Scope of work': 'Périmètre des travaux',
  'Assumptions': 'Hypothèses',
  'Constraints': 'Contraintes',
  'Timeline and milestones': 'Calendrier et jalons',
  'Fees and payment schedule': 'Honoraires et échéancier',
  'Acceptance procedure': 'Procédure d’acceptation',
  'Annex A — Acceptance criteria': 'Annexe A — Critères d’acceptation',
  'Signatures': 'Signatures',
  // table heads / labels
  'Ref': 'Réf.',
  'Requirement': 'Exigence',
  'Priority': 'Priorité',
  'Type': 'Type',
  'Delivered by': 'Livré par',
  'Deliverable and acceptance criteria': 'Livrable et critères d’acceptation',
  'Milestone': 'Jalon',
  'Done when:': 'Terminé lorsque :',
  'Satisfies': 'Satisfait',
  'Criterion': 'Critère',
  'Measured by': 'Mesuré par',
  'Client': 'Client',
  'Consultant': 'Consultant',
  'Engagement': 'Mandat',
  'Client contact': 'Contact client',
  'Commercial model': 'Modèle commercial',
  'Period': 'Période',
  'Governing law': 'Droit applicable',
  'Fee basis': 'Base des honoraires',
  'Total fees': 'Honoraires totaux',
  'Invoicing': 'Facturation',
  'Payment terms': 'Conditions de paiement',
  'Expenses': 'Frais',
  'Status': 'Statut',
  'For the Client': 'Pour le client',
  'For the Consultant': 'Pour le consultant',
  'name, title, date': 'nom, fonction, date',
  'The Consultant': 'Le Consultant',
  'To be nominated': 'À désigner',
  'to be agreed': 'à convenir',
  'in-scope requirements': 'exigences dans le périmètre',
  'deliverables': 'livrables',
  'acceptance criteria': 'critères d’acceptation',
  // type / priority values
  // empty states
  'None recorded in the register.': 'Rien n’est enregistré dans le registre.',
  'No in-scope requirements are recorded in the register.': 'Aucune exigence dans le périmètre n’est enregistrée dans le registre.',
  'No deliverables are recorded for this engagement.': 'Aucun livrable n’est enregistré pour ce mandat.',
  'No milestones are recorded for this engagement.': 'Aucun jalon n’est enregistré pour ce mandat.',
  'No background has been recorded for this engagement.': 'Aucun contexte n’est enregistré pour ce mandat.',
  'No acceptance criteria recorded.': 'Aucun critère d’acceptation enregistré.',
  'No acceptance criteria are recorded. Acceptance will be assessed against the definitions of done above.': 'Aucun critère d’acceptation n’est enregistré. L’acceptation sera évaluée selon les définitions de terminé ci-dessus.',
  // SOW copy
  'The Consultant shall deliver the requirements set out below. These requirements, and only these requirements, form the agreed baseline for this Statement of Work. {must} of {total} are classified as must.': 'Le Consultant livrera les exigences énoncées ci-dessous. Ces exigences, et elles seules, constituent la ligne de base convenue de ce Statement of Work. {must} sur {total} sont classées « must ».',
  'The following are expressly not included in this Statement of Work. They are listed because they were discussed: their absence here is deliberate, not an oversight. Bringing any of them into scope requires an approved Change Request.': 'Les éléments suivants sont expressément exclus de ce Statement of Work. Ils sont listés parce qu’ils ont été discutés : leur absence est délibérée, non un oubli. Les intégrer au périmètre exige une demande de changement approuvée.',
  'This Statement of Work is priced and scheduled on the following assumptions. If an assumption proves false, the affected work is handled under Change control.': 'Ce Statement of Work est chiffré et planifié sur la base des hypothèses suivantes. Si une hypothèse s’avère fausse, les travaux concernés relèvent de la gestion des changements.',
  'The following constraints bind the solution and were treated as fixed when scoping this work.': 'Les contraintes suivantes s’imposent à la solution et ont été considérées comme fixes lors de la définition du périmètre.',
  'Each deliverable is presented for acceptance against its definition of done and the acceptance criteria in Annex A. The Client reviews within {n} working days of issue; a deliverable not rejected in writing within that window is deemed accepted.': 'Chaque livrable est présenté pour acceptation au regard de sa définition de terminé et des critères d’acceptation de l’annexe A. Le client dispose de {n} jours ouvrables après remise ; un livrable non refusé par écrit dans ce délai est réputé accepté.',
});
